<template>
  <div
    class="page-number-container flex flex-no-wrap w-auto overflow-auto bg-white"
  >
    <button
      v-if="!getPagesToRender.includes(1)"
      title="Go to page 1"
      style="color: #3490dc;"
      class="rounded-full text-blue page-number flex-no-shrink"
      @click="handleClick(1)"
    >
      1
    </button>
    <span v-if="!getPagesToRender.includes(1)" class="bullet">• • •</span>
    <button
      v-for="currentPage in getPagesToRender"
      :key="currentPage + 'page_number'"
      :title="`Go to page ${currentPage}`"
      :style="
        currentPage === page
          ? 'color: white; background-color: #3490dc; filter: brightness(1);'
          : ''
      "
      class="rounded-full text-blue page-number flex-no-shrink"
      @click="handleClick(currentPage)"
    >
      {{ currentPage }}
    </button>
    <span
      v-if="
        !getPagesToRender.includes(getPageNumbers.length - 1) &&
          getPageNumbers.length > 10
      "
      class="bullet"
      >• • •</span
    >
    <button
      v-if="
        !getPagesToRender.includes(getPageNumbers.length - 1) &&
          getPageNumbers.length > 10
      "
      :title="`Go to page ${getPageNumbers.length - 1}`"
      style="color: #3490dc;"
      class="rounded-full text-blue page-number flex-no-shrink"
      @click="handleClick(getPageNumbers.length)"
    >
      {{ getPageNumbers.length }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    pages: {
      type: Number,
      default: 0,
    },
    page: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      pagesToRender: [],
    }
  },
  computed: {
    getPageNumbers() {
      const tempArray = []
      for (let i = 0; i < this.pages; i++) {
        tempArray.push(i + 1)
      }
      return tempArray
    },
    getPagesToRender() {
      let tempArray = []
      if (this.page === this.getPageNumbers[0]) {
        tempArray = this.getPageNumbers.slice(0, 10)
      } else if (
        this.page === this.getPageNumbers[this.getPageNumbers.length - 1]
      ) {
        tempArray = this.getPageNumbers.slice(this.pages - 10)
      } else {
        let start = this.page - 5
        if (start <= 0) {
          start = 0
        }
        tempArray = this.getPageNumbers.slice(start, this.page)
        tempArray.push(...this.getPageNumbers.slice(this.page, this.page + 5))
      }
      return tempArray
    },
  },
  methods: {
    handleClick(clickedPage) {
      if (clickedPage !== this.page) {
        this.$emit("click", clickedPage)
      }
    },
  },
}
</script>

<style scoped>
.page-number-container {
  padding: 0.3rem;
}

.page-number-container::after,
.page-number-container::before {
  padding-right: 0.5rem;
  content: "";
}

.bullet {
  padding: 0.7rem;
  color: #3490dc;
}

.page-number {
  width: auto;
  height: auto;
  margin: 0;
  padding: 0.7rem;
  border-radius: 4px;
}
.page-number:hover,
.page-number:active,
.page-number:focus {
  color: #3490dc;
  background: transparent;
  filter: brightness(0.5);
}

.page-number-container::after {
  padding-right: 1rem;
}
</style>
